/* dashboard-rediseno (15-oct-2026): LA ANATOMIA FIJA DE LA TARJETA DEL PANEL.

   ARCHIVO EN ASCII A PROPOSITO (regla de la casa para los `.js` nuevos).

   Regla 4 del documento de diseno: todas las tarjetas de una fila miden lo mismo, sea cual
   sea su estado, y cambiar de estado no mueve nada. Por eso la tarjeta no tiene un alto que
   dependa de lo que lleva: tiene TRES zonas de alto fijo, con las MISMAS clases en todos los
   estados (lo fija Dashboard.panel.dr.test.js contra estas constantes):
     - encabezado: 40 px (el icono de 40 y el titulo, que reserva dos renglones de 20);
     - detalle: 36 px de dos renglones de 18 MAS los 12 de aire hasta el pie (48 en total).
       Cuando el renglon 2 lleva un boton chico mide 24 y el aire baja a 6: la suma es la misma,
       asi que la zona no cambia;
     - pie: 44 px (el medidor a la izquierda y un solo boton a la derecha).
   Entre el encabezado y el detalle van 10 px. La tarjeta lleva 16 de relleno: mide
   16 + 40 + 10 + 48 + 44 + 16 = 174 px en cualquier estado.

   La tarjeta interna (parte de un documento dividido y publicacion de un grupo) usa la misma
   idea con su propio relleno de 14 y su icono de 36.

   Las cadenas van COMPLETAS y literales: Tailwind las encuentra escaneando el archivo. */
import React from 'react';

// La rejilla de la lista: 1 columna, 2 desde 640 de ventana y 3 desde 1181 (4.1 del encargo);
// el acomodo denso de la rejilla, para que un padre abierto a lo ancho no deje hueco.
export const REJILLA_DEL_PANEL = 'grid grid-cols-1 min-[640px]:grid-cols-2 min-[1181px]:grid-cols-3 grid-flow-row-dense gap-4';
// La rejilla de adentro de un grupo o de un padre abierto (12 px entre tarjetas).
export const REJILLA_INTERNA = 'grid grid-cols-1 min-[640px]:grid-cols-2 min-[1181px]:grid-cols-3 grid-flow-row-dense gap-3';
// Lo que ocupa toda la fila de la rejilla (el grupo, el padre abierto, el panel de fotos).
export const A_LO_ANCHO = 'col-span-full';

// La tarjeta de documento y la interna.
// Segunda vuelta (D1 y D9): cada tarjeta es el grupo `tarjeta` de sus marcas de ancho (anchoDeTarjeta.js).
export const TARJETA = 'relative flex flex-col rounded-[18px] border border-[#222222] bg-[#141414] p-4 group/tarjeta';
export const TARJETA_INTERNA = 'relative flex flex-col rounded-[14px] border border-[#1F1F1F] bg-[#101010] p-3.5 group/tarjeta';
// El borde de la tarjeta que espera que el alumno la procese (A5 y A9).
export const BORDE_POR_PROCESAR = '#3A2414';

// Las tres zonas.
export const ZONA_ENCABEZADO = 'flex items-start gap-3 h-10 shrink-0';
export const ZONA_DETALLE = 'mt-2.5 h-12 shrink-0 flex flex-col min-w-0';
// Con texto estrecho (D9) el pie aprieta su hueco de 12 a 8.
export const ZONA_PIE = 'h-11 shrink-0 flex items-center gap-3 group-data-[estrecha]/tarjeta:gap-2 min-w-0';
// La parte reserva UN renglon de titulo: su encabezado mide 36 (el icono interno).
export const ZONA_ENCABEZADO_PARTE = 'flex items-center gap-3 h-9 shrink-0';

// El icono: 40 en la tarjeta, 36 en la interna; el fondo y el trazo naranja suave de la casa.
export const CAJA_ICONO = 'w-10 h-10 rounded-xl bg-[#1C130D] flex items-center justify-center shrink-0';
export const CAJA_ICONO_INTERNA = 'w-9 h-9 rounded-[10px] bg-[#1C130D] flex items-center justify-center shrink-0';
export const TRAZO_ICONO = 'w-5 h-5 text-[#F7A06A]';
export const TRAZO_ICONO_INTERNA = 'w-4 h-4 text-[#F7A06A]';

// El titulo: 15 px seminegrita, dos renglones reservados de 20 y "..." despues.
export const TITULO = 'flex-1 min-w-0 h-10 text-[15px] leading-5 font-semibold text-[#F4F4F3] line-clamp-2 break-words';
export const TITULO_PARTE = 'flex-1 min-w-0 text-[15px] leading-5 font-semibold text-[#F4F4F3] truncate';

// Los renglones del detalle: 13 px con alto de linea de 18, gris secundario.
export const RENGLON = 'h-[18px] text-[13px] leading-[18px] text-[#9A9A9A] truncate';
export const RENGLON_DOS = 'h-[18px] text-[13px] leading-[18px] text-[#9A9A9A] flex items-center gap-1.5 min-w-0';
export const RENGLON_DOS_CON_BOTON = 'h-6 flex items-center gap-1.5 group-data-[angosta]/tarjeta:gap-1 min-w-0';
// Un aviso largo ocupa los dos renglones (36 px) y se corta con "..." si no cabe.
export const AVISO_LARGO = 'h-9 text-[13px] leading-[18px] line-clamp-2 break-words';

// El boton chico del renglon 2 (A10 y A11): 24 de alto, 44 de toque.
// Tercera vuelta (D20): con su capa propia (z 1), su area de 44 queda encima del renglon del tipo.
export const BOTON_CHICO = 'relative z-[1] inline-flex items-center gap-1 h-6 px-[9px] rounded-lg bg-[#1B1B1B] border border-[#2C2C2C] text-[#F4F4F3] text-[12.5px] font-semibold whitespace-nowrap shrink-0 disabled:opacity-45';
// La liga del renglon 2 (A12 y A14): 13 px seminegrita naranja, 44 de toque.
export const LIGA_RENGLON = 'relative inline-flex items-center gap-1 text-[13px] leading-[18px] font-semibold text-[#F7A06A] min-w-0';

// El boton del pie: 14 px seminegrita, 40 de alto; 44 abajo de 768 (segunda vuelta, D2: "40 px de
// alto, 44 px en celular"; el pie mide 44, asi que la tarjeta no cambia de alto).
export const BOTON_PIE = 'inline-flex items-center justify-center gap-1.5 h-10 max-[767px]:h-11 px-3.5 rounded-xl text-[14px] font-semibold whitespace-nowrap shrink-0 disabled:opacity-45';
// El icono de "View topics": se va cuando el texto de la tarjeta es estrecho (D9).
export const ICONO_VER_TEMAS = 'w-4 h-4 group-data-[estrecha]/tarjeta:hidden';
export const BOTON_PIE_SECUNDARIO = `${BOTON_PIE} bg-[#1B1B1B] border border-[#2C2C2C] text-[#F4F4F3]`;
export const BOTON_PIE_PRINCIPAL = `${BOTON_PIE} bg-[#F27A2E] text-[#160A02]`;

// La barra del medidor: 6 px sobre la pista de la casa.
export const PISTA = 'h-1.5 w-full rounded-full bg-[#262626] overflow-hidden';
export const COLOR_BARRA_PROCESANDO = '#D4D4D4';
export const COLOR_BARRA_QUIETA = '#4A4A4A';

// La atenuacion de la tarjeta bloqueada o caducada: icono, titulo y detalle al 50 %.
export const ATENUADA_50 = 'opacity-50';

// Un area de toque de 44 que no cambia el dibujo (el patron de la casa: un span vacio,
// absoluto y centrado; el control lleva posicion relativa).
//
// Segunda vuelta (D2 y D16): centrada, el area de un control del renglon 2 bajaba hasta el pie
// (y pisaba la de su boton), y la del icono de informacion de A4 subia hasta la del menu de tres
// puntos. `abajo` (px) fija cuanto baja del control y el resto sube; `arriba` (px), cuanto sube y
// el resto baja. Sin las dos, centrada como siempre.
export function AreaDe44({ abajo, arriba } = {}) {
  const vertical = typeof abajo === 'number'
    ? { bottom: -abajo }
    : typeof arriba === 'number' ? { top: -arriba } : null;
  const estilo = vertical
    ? { position: 'absolute', left: '50%', width: 44, height: 44, minWidth: '100%', transform: 'translateX(-50%)', ...vertical }
    : { position: 'absolute', left: '50%', top: '50%', width: 44, height: 44, minWidth: '100%', minHeight: '100%', transform: 'translate(-50%, -50%)' };
  return <span aria-hidden="true" data-area-tocable="" style={estilo} />;
}
// Lo que puede bajar el area de un control del renglon 2 sin entrar al pie.
export const BAJA_DEL_RENGLON_DOS = 6;

// El nombre de un archivo se parte de preferencia despues de "_" o de "."; si no, en
// cualquier letra (el corte de palabras largas del titulo). Se marca con <wbr>, que no cambia el texto.
export function nombreConCortes(nombre) {
  const texto = typeof nombre === 'string' ? nombre : '';
  const piezas = [];
  let actual = '';
  let i = 0;
  for (const letra of texto) {
    actual += letra;
    if (letra === '_' || letra === '.') {
      piezas.push(actual, <wbr key={`c${i}`} />);
      actual = '';
    }
    i += 1;
  }
  if (actual) piezas.push(actual);
  return piezas;
}
